import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const listingsControlsSideBar = css`
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      position: sticky;
      top: ${pxToRem(spacing.xl)};
      max-height: calc(100vh - ${spacing.xxxl}px);
      padding-bottom: ${spacing.xxxl}px;
      overflow-x: hidden;
      overflow-y: auto;
    `,
  )};
`;
